import { usePremiumAccess } from '@hellodarwin/app-core/lib/providers/premium-access-provider';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import NotificationPreferences from '@hellodarwin/core/lib/components/notifications/preferences';
import { NotificationPreferencesCardContainer } from '@hellodarwin/core/lib/components/notifications/preferences/styles';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/app-hooks';
import {
  fetchContact,
  selectContact,
  toggleGrantDigest,
  toggleNewsletter,
  toggleProgramUpdates,
} from '../../features/api/slices/profile-slice';
import { useClientApi } from '../../features/api/use-client-api';
import { AlertPreferencesContainer, NotificationsContainer } from './styles';

const AlertPreferences = () => {
  const dispatch = useAppDispatch();
  const api = useClientApi();
  const contact = useAppSelector(selectContact);
  const { accessLevel, handleCheckout } = usePremiumAccess();
  const { t } = useTranslations();

  useEffect(() => {
    dispatch(fetchContact({ api, syncSendGrid: true }));
  }, [api, dispatch]);

  return (
    <AlertPreferencesContainer>
      <NotificationsContainer>
        <Typography elementTheme="h6">
          {t('grantNotificationJourneys|preferencesTitle')}
        </Typography>
        <Typography elementTheme="body1">
          {t('grantNotificationJourneys|preferencesBody')}
        </Typography>
      </NotificationsContainer>
      <NotificationPreferencesCardContainer>
        <NotificationPreferences
          contact={contact}
          toggleProgramUpdates={() => dispatch(toggleProgramUpdates({ api }))}
          toggleNewsletter={() => dispatch(toggleNewsletter({ api }))}
          toggleGrantDigest={() => dispatch(toggleGrantDigest({ api }))}
          isProgramUpdatesLocked={accessLevel === 'free'}
          onProgramUpdatesLockedClick={handleCheckout}
        />
      </NotificationPreferencesCardContainer>
    </AlertPreferencesContainer>
  );
};

export default AlertPreferences;
